import { styled, Stack } from '@/theme/index';

export interface LinearGaugeChartProps {
  color: string;
  value: number;
}

interface BottomBarProps {
  color: string;
}

const TopBar = styled(Stack)<LinearGaugeChartProps>(({ color, value }) => ({
  zIndex: '2',
  position: 'absolute',
  width: `${value}%`,
  height: '10px',
  borderRadius: '40px',
  backgroundColor: color,
}));

const BottomBar = styled(Stack)<BottomBarProps>(({ color }) => ({
  zIndex: '1',
  position: 'absolute',
  height: '10px',
  width: '100%',
  opacity: '10%',
  borderRadius: '40px',
  backgroundColor: color,
}));

export function LinearGaugeChart({ color, value }: LinearGaugeChartProps) {
  return (
    <Stack sx={{ width: '100%', position: 'relative' }}>
      <BottomBar color={color} />
      <TopBar color={color} value={value} />
    </Stack>
  );
}
